import styled from "styled-components";
import { useState, useEffect } from "react";
import { useAuthContext } from "../hooks/auth/AuthContext";
import { useSettingsContext } from "../hooks/settings/SettingsContext";
import Furigana from "../components/furigana";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Checkbox from "@mui/material/Checkbox";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";

import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";

const StyledMainBox = styled(Box)`
  height: calc(100% - 120px);
  overflow: scroll;
`;

const StyledPaper = styled(Paper)`
  max-height: ${(props) => props.display};
  margin: 5px;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  transition: all ${(props) => props.smooth} ease-in-out;
  ${(props) => props.selected && "background-color: #0d6efd50"};
  &:hover {
    border-color: #4fc3f7;
  }
`;

const StyledLeftColumnBox = styled(Box)`
  padding-top: 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const StyledCenterColumnBox = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledRightColumnBox = styled(Box)`
  padding-top: 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const StyledHeaderBox = styled(Box)`
  border: ${(props) => (props.$hide ? "1px solid #4fc3f7" : "1px solid #4fc2f700")};
  border-radius: 10px;
  margin: 5px;
  display: flex;
  justify-content: space-between;
  transition: border 0.5s;
`;

const StyledHeaderFieldBox = styled(Box)`
  width: ${(props) => (props.$edge ? "50px" : "calc(50% - 50px)")};
  // width: calc(50% - 50px);
  // ${(props) => (!props.$edge && props.$hide && { width: "0px" })}
  // ${(props) => (props.$edge && props.$hide && { width: "0px" })}
  display: flex;
  flex-direction: column;
  justify-content: center;
  visibility: ${(props) => (props.$hide ? "hidden" : "visible")};
  opacity: ${(props) => (props.$hide ? "0" : "1")};
  transition:
    width 0.5s,
    visibility 0.5s,
    opacity 0.5s linear;
`;

const StyledDetailBox = styled(Box)`
  margin: 10px;
  display: flex;
  flex: 1 1 0px;
  justify-content: space-between;
  visibility: ${(props) => (props.$hide ? "hidden" : "visible")};
  opacity: ${(props) => (props.$hide ? "0" : "1")};
  transition:
    visibility 0.5s,
    opacity 0.5s linear;
`;

const StyledDetailLeftBox = styled(Box)`
  display: flex;
  flex: 1 1 0px;
  flex-direction: column;
`;

const StyledDetailRightBox = styled(Box)`
  display: flex;
  flex: 1 1 0px;
  flex-direction: column;
`;

const StyledFieldBox = styled(Box)`
  border: 1px solid #4fc3f7;
  border-radius: 10px;
  margin: 5px;
  padding: 10px;
`;

const StyledEmptyBox = styled(Box)`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TableVocabulary = ({ selectedCategory, vocabularyList, page, pageSize, practiceList, updatePracticeList, setWordForm, setOpenForm }) => {
  const { user } = useAuthContext();
  const { furigana, romanji } = useSettingsContext();
  const [displayDetails, setDisplayDetails] = useState(-1);

  useEffect(() => {
    setDisplayDetails(d => d !== -1 ? -2 : d);
  }, [page]);

  return (
    <StyledMainBox>
      {selectedCategory ? (
        <>
          {vocabularyList.slice((page - 1) * pageSize, page * pageSize).map((word, index) => {
            return (
              <StyledPaper
                key={`row${index}`}
                selected={practiceList.findIndex((p) => p.selfid === word.selfid) > -1}
                smooth={displayDetails !== -2 ? "0.5s" : "0s"}
                display={index === displayDetails ? "450px" : "80px"}
              >
                <StyledLeftColumnBox>
                  <Checkbox checked={practiceList.findIndex((p) => p.selfid === word.selfid) >= 0} onChange={() => updatePracticeList(word)} />
                </StyledLeftColumnBox>

                <StyledCenterColumnBox>
                  <StyledHeaderBox $hide={index === displayDetails}>
                    <StyledHeaderFieldBox $hide={index === displayDetails} $sizable={index === displayDetails} $edge>
                      <Box sx={{ position: "relative", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <CircularProgress
                          variant="determinate"
                          value={(6 - word.jlpt) * 20}
                          size={50}
                          thickness={3}
                          sx={{
                            color: "#4fc3f7",
                            "& .MuiCircularProgress-circle": { strokeLinecap: "round" },
                          }}
                        />
                        <Box
                          sx={{
                            top: 0,
                            left: 0,
                            bottom: 0,
                            right: 0,
                            position: "absolute",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Typography variant="caption" component="div" sx={{ color: "white", fontWeight: "bold", fontSize: "1.2rem" }}>
                            N{word.jlpt}
                          </Typography>
                        </Box>
                      </Box>
                    </StyledHeaderFieldBox>
                    <StyledHeaderFieldBox $sizable>
                      <Furigana furigana={furigana} center text={word.japanese} />
                      {romanji && (
                        <Typography variant="subtitle2" align="center" color="textSecondary">
                          {word.selfid.split("-")[1]}
                        </Typography>
                      )}
                    </StyledHeaderFieldBox>
                    <StyledHeaderFieldBox $hide={index === displayDetails} $sizable>
                      {word.french.map((f, index) => (
                        <Typography key={`row${index}`} variant="body2" noWrap>
                          • {f}
                        </Typography>
                      ))}
                    </StyledHeaderFieldBox>
                    <StyledHeaderFieldBox $hide={index === displayDetails} $sizable={index === displayDetails} $edge>
                      <Box sx={{ position: "relative", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <CircularProgress
                          variant="determinate"
                          value={word.masteryLevel * 20}
                          size={30}
                          thickness={3}
                          sx={{
                            color: "#4fc3f7",
                            "& .MuiCircularProgress-circle": { strokeLinecap: "round" },
                          }}
                        />
                        <Box
                          sx={{
                            top: 0,
                            left: 0,
                            bottom: 0,
                            right: 0,
                            position: "absolute",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Typography variant="caption" component="div" sx={{ color: "white", fontWeight: "bold", fontSize: "1.2rem" }}>
                            {word.masteryLevel}/5
                          </Typography>
                        </Box>
                      </Box>
                    </StyledHeaderFieldBox>
                  </StyledHeaderBox>

                  <StyledDetailBox $hide={index !== displayDetails}>
                    <StyledDetailLeftBox>
                      <StyledFieldBox>
                        <Box sx={{ position: "relative", display: "flex", justifyContent: "center", alignItems: "center" }}>
                          <CircularProgress
                            variant="determinate"
                            value={(6 - word.jlpt) * 20}
                            size={50}
                            thickness={3}
                            sx={{
                              color: "#4fc3f7",
                              "& .MuiCircularProgress-circle": { strokeLinecap: "round" },
                            }}
                          />
                          <Box
                            sx={{
                              top: 0,
                              left: 0,
                              bottom: 0,
                              right: 0,
                              position: "absolute",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Typography variant="caption" component="div" sx={{ color: "white", fontWeight: "bold", fontSize: "1.2rem" }}>
                              N{word.jlpt}
                            </Typography>
                          </Box>
                        </Box>
                      </StyledFieldBox>
                      <StyledFieldBox>
                        <Typography variant="body1">
                          <CategoryOutlinedIcon fontSize="small" color="primary" />
                          Type: {word.type}
                        </Typography>
                      </StyledFieldBox>
                      <StyledFieldBox>
                        <Typography variant="body1">
                          <FolderOutlinedIcon fontSize="small" color="primary" />
                          Catégories:
                        </Typography>
                        {word.category.map((c, index) => (
                          <Typography key={`c${index}`} variant="body2">
                            • {c}
                          </Typography>
                        ))}
                      </StyledFieldBox>
                    </StyledDetailLeftBox>
                    <StyledDetailRightBox>
                      <StyledFieldBox>
                        <Typography variant="body1">
                          <FlagOutlinedIcon fontSize="small" color="primary" />
                          Français:
                        </Typography>
                        {word.french.map((w, index) => (
                          <Typography key={`row${index}`} variant="body2" sx={{ marginLeft: "10px" }}>
                            • {w}
                          </Typography>
                        ))}
                      </StyledFieldBox>
                      {!!word.detail && (
                        <StyledFieldBox>
                          <Typography variant="body1">
                            <InfoOutlinedIcon fontSize="small" color="primary" />
                            Détail:
                          </Typography>
                          <Typography variant="body2">{word.detail}</Typography>
                        </StyledFieldBox>
                      )}
                    </StyledDetailRightBox>
                  </StyledDetailBox>

                  <IconButton
                    variant="outlined"
                    onClick={() => {
                      setWordForm(word);
                      setOpenForm(true);
                    }}
                    size="small"
                    sx={{ alignSelf: "center" }}
                    disabled={!user}
                  >
                    <EditIcon />
                  </IconButton>

                  <StyledDetailBox $hide={index !== displayDetails}>
                    <StyledFieldBox>
                      <Typography variant="body2" color="textSecondary">
                        Identifiant:
                      </Typography>
                      <Typography variant="body2">{word.selfid}</Typography>
                    </StyledFieldBox>

                    {!!word.linkid.length && (
                      <StyledFieldBox>
                        <Typography variant="body2" color="textSecondary">
                          Identifiants liés:
                        </Typography>
                        {word.linkid.map((l, index) => (
                          <Typography key={`l${index}`} variant="body2">
                            • {l}
                          </Typography>
                        ))}
                      </StyledFieldBox>
                    )}
                  </StyledDetailBox>
                </StyledCenterColumnBox>

                <StyledRightColumnBox>
                  <IconButton variant="outlined" onClick={() => setDisplayDetails(displayDetails !== index ? index : -1)} sx={{ transform: `rotate(${displayDetails === index ? "180deg" : "0deg"})` }}>
                    <KeyboardArrowDownIcon />
                  </IconButton>
                </StyledRightColumnBox>
              </StyledPaper>
            );
          })}
        </>
      ) : (
        <StyledEmptyBox>Aucunes données</StyledEmptyBox>
      )
      }
    </StyledMainBox >
  );
};

export default TableVocabulary;
